import { useDisclosure, Box, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Flex, Text } from "@chakra-ui/react"
import { OrganizationUnitGridItem, OrganizationUnitPagedQuery } from "BrokerTsLib/src/dtos"
import { useState, useEffect } from "react"
import { OrganizationListContactPersonColumn as OrganizationListContactColumn, OrganizationListCityColumn, OrganizationListNameColumn, OrganizationListTypeColumn, OrganizationsList } from "../organization/OrganizationList"
import { OrganizationListFilter } from "../organization/OrganizationListFilter"
import { Add } from "../../icons"
import { useGetAll } from "BrokerTsLib/src/hooks/useOrganizationUnit"
import { ListItemAddedButton } from "../shared/ListItemActionButtons"
import { organizationListContext } from "brokertslib/src/context"

const pageSize = 15
export const AddFlexGroupMember = ({ onAddMember, alreadyAdded }: { onAddMember: (item: OrganizationUnitGridItem) => void, alreadyAdded: OrganizationUnitGridItem[] }) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [filter, setFilter] = useState<OrganizationUnitPagedQuery>({ showInvalid: false, showRootOnly: false, pageIndex: 1, pageSize, showAllItems: true })

    const { data, mutateAsync: getAll, isLoading } = useGetAll()

    useEffect(() => {
        if (isOpen)
            getAll(filter)
    }, [isOpen, filter]);

    const possibleOrganizations = data?.data.items.filter(x => !alreadyAdded.some(y => y.id === x.id)) ?? []

    return (
        <Box>
            <Button size={'sm'} colorScheme='primary' onClick={() => onOpen()}><Add /> Přidat organizaci do flexibilní skupiny</Button>
            <Modal size="4xl" isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />

                <ModalContent>
                    <ModalHeader>
                        <Text>Přidat organizaci do flexibilní skupiny</Text>
                        <ModalCloseButton />
                    </ModalHeader>

                    <ModalBody sx={{ pt: 0, pb: 6, gap: 4 }}>
                        <organizationListContext.Provider value={{
                            loading: isLoading,
                            totalCount: data?.data.totalCount ?? 0,
                            currentPage: 1,
                            pageSize,
                            filter,
                            setCurrentPage: () => { },
                            setPageSize: () => { },
                            updateFilter: setFilter,
                            reload: () => getAll(filter)
                        }}>
                            <Flex flexDir={'column'} gap={4}>
                                <OrganizationListFilter />
                                <OrganizationsList organizations={possibleOrganizations} withPaginator={true} sx={{ boxShadow: 'none' }}
                                    columnsDefinition={[
                                        OrganizationListNameColumn,
                                        OrganizationListContactColumn,
                                        OrganizationListCityColumn,
                                        OrganizationListTypeColumn,
                                        { key: 'actions', name: '', cellExpr: (item) => <ListItemAddedButton sx={{ ml: 'auto' }} onClick={() => onAddMember(item)} /> }
                                    ]}
                                />
                            </Flex>
                        </organizationListContext.Provider>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Box>

    )
}